export const environment = {
  api: 'https://apidev.kdotoutreach.com/api',
  identity: 'https://accountsdev.kdotoutreach.com',
  production: true,
  clientLogo: './assets/logos/kdot-logo.png',
  clientFavicon: './assets/logos/kdot-favicon.png',
};
